import { render, staticRenderFns } from "./CourseContentsTemplate16.vue?vue&type=template&id=128494e6&"
import script from "./CourseContentsTemplate16.vue?vue&type=script&lang=js&"
export * from "./CourseContentsTemplate16.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports